import { useRegions } from '../../regions/provider'
import { replaceDynamicVars } from '../../regions/utils/replacer'

import { Props } from './model'
import { View } from './view'

export const BlockMain = (props: Props) => {
	const regions = useRegions()
	const replacedProps = replaceDynamicVars(regions.currentCity, {
		title: props.data.title,
	})

	return View({
		...props,
		data: {
			...props.data,
			title: replacedProps.title,
		},
	})
}
